/* Mobile homepage sequence only. Move whole existing sections, preserving
   their controls and widget identities. Restore the original DOM on desktop.
   The configurator itself stays mounted in its original section. */
(() => {
  if (!document.body.classList.contains('template-index')) return;

  const mobile = window.matchMedia('(max-width: 749px)');
  const positions = new Map();

  const updateOrder = () => {
    const main = document.getElementById('MainContent');
    if (!main) return;

    for (const [section, marker] of positions) {
      if (!section.isConnected) {
        marker.remove();
        positions.delete(section);
      }
    }

    if (!mobile.matches) {
      for (const [section, marker] of positions) {
        if (marker.isConnected) marker.before(section);
        marker.remove();
      }
      positions.clear();
      return;
    }

    const sectionFor = (selector) => {
      const section = main.querySelector(selector)?.closest('.shopify-section');
      return section?.parentElement === main ? section : null;
    };
    const configurator = sectionFor('.zkx');
    const google = sectionFor('.z30-google-proof');
    if (!configurator || !google) return;

    const reviews = sectionFor('.z30-reviews-block');
    const projects = sectionFor('.z30-project-proof');
    const pathways = sectionFor('.z30-pathways');
    const sequence = [reviews, projects, pathways].filter(Boolean);

    for (const section of sequence) {
      if (!positions.has(section)) {
        const marker = document.createComment('ZAUN030 original desktop section position');
        section.before(marker);
        positions.set(section, marker);
      }
    }

    let previous = configurator;
    for (const section of sequence) {
      if (previous.nextElementSibling !== section) previous.after(section);
      previous = section;
    }
  };

  updateOrder();
  mobile.addEventListener('change', updateOrder);
  document.addEventListener('shopify:section:load', updateOrder);
  document.addEventListener('shopify:section:unload', updateOrder);
})();
